import React, { Component } from 'react';
import { ConfigProvider } from "@tinper/next-ui";
import CommonPickerPc from '../CommonPicker';
import Tabs from './Tabs';
import SearchTable from './SearchTable';
import Dropdown from './Dropdown';
import Tree from './Tree';
import './style'
import { REFER_TYPE } from '../../utils/refer_context/referType';

export default class ReferListPc extends Component {
  referContext = null;

  // 获得逻辑层上下文对象
  setReferContext(ctx) {
    this.referContext = ctx;
  }

  // 获取弹窗内容
  async getView () {
    try {
      this.referContext.props.pageStore.startLoading()
    } catch {
      console.error("没配置pageStore!")
    }
    try {
      // 获取参照元数据和参照类型
      let { metaData, referType, topName, showStopStatus, newRefMeta } = await this.referContext.getMetaData(); 
      // 下拉方式
      if (this.referContext.props.subuiType === 'drop' && REFER_TYPE.from(referType) !== REFER_TYPE.TREE_TABLE) { // 树表参照不能用下拉方式展示
        this.isTreeTable = false;
        if (REFER_TYPE.from(referType) === REFER_TYPE.TABLE) { // 表参照
          return <Dropdown searchKey={this.referContext.searchKey} referContext={this.referContext} metaData={metaData} isMultiple={this.referContext.isMultiple} newRefMeta={newRefMeta} />
        } else if (REFER_TYPE.from(referType) === REFER_TYPE.TREE) { // 树参照
          return <Tree referContext={this.referContext} isMultiple={this.referContext.isMultiple} showStopStatus={showStopStatus} dropdown={true} searchKey={this.referContext.searchKey} />
        }
      } else {
        this.isTreeTable = true;
      }
      // 智能搜索
      if (this.referContext.isSearch) {
        return <SearchTable searchKey={this.referContext.searchKey} referContext={this.referContext} metaData={metaData} isMultiple={this.referContext.isMultiple} newRefMeta={newRefMeta} />
      }
      return <Tabs referType={referType} referContext={this.referContext} metaData={metaData} showStopStatus={showStopStatus} topName={topName} newRefMeta={newRefMeta} />;  
    } catch (error) {
      this.referContext.props.pageStore.endLoading()
    }
  }

  // 打开弹窗 使用 CommonPickerPc 进行参照的渲染
  async open(elementId) {
    let refView = await this.getView()
    this.referContext.props.pageStore.endLoading()
    // 下拉方式展示
    if (this.referContext.showPopover && !this.isTreeTable || this.referContext.isSearch) {
      this.referContext.showPopover(refView)
      return;
    }
    const { modalTitle, caption, modalWidth, modalHeight, modalResizable = true, modalDraggable = true, modalMaximize= true, getPopupContainerDom, caption_resid } = this.referContext.props;
    ReactDOM.render(
      <ConfigProvider locale={this.referContext.props.pageStore.rootStore?.context?.locale || 'zh_CN'}>
        <CommonPickerPc
          title={<div langid={caption_resid} placement='top'>{modalTitle || caption || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00033', '标题', undefined, {returnDom: true, placement: 'top'})}</div>}
          okClick={() => { this.referContext.okClick() }}
          close={() => { this.close(elementId) }}
          width={modalWidth || '1000px'}
          height={modalHeight || '80%'}
          bodyClassName='refer-picker-body'
          visible={true}
          resizable={modalResizable}
          draggable={modalDraggable}
          maximize={modalMaximize ? modalMaximize : false}
          getPopupContainerDom={getPopupContainerDom}
          alias={this.referContext.props.alias}
          fieldid={this.referContext.props.fieldid}
          fieldidPrefix={this.referContext.props.fieldidPrefix}
          cancelText={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000A', '取消', undefined, {returnDom: true, placement: 'top'})}
          okText={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0002F', '确定', undefined, {returnDom: true, placement: 'top'})}
        >
          {refView}
        </CommonPickerPc>
      </ConfigProvider>
      ,
      elementId
    );
  }

  // 关闭弹窗
  close(elementId) {
    // 卸载弹窗组件
    elementId && ReactDOM.unmountComponentAtNode(elementId);
    this.referContext.close();
  }
}
